import { messages } from '@fruitways/shared';
import { EmptyState, SkeletonRows } from '@/components';
import { AppFrame } from '@/app/AppFrame';
import { ProfileMenu } from '@/app/ProfileMenu';
import {
  groupByFarm,
  seasonForToday,
  useEstimates,
  useMasterData,
  visibleWeekStarts,
} from '@/hooks/useMasterData';
import { EstimateRow } from '@/screens/Dashboard/EstimateRow';
import { AdminEstimates } from '@/screens/Dashboard/AdminEstimates';
import { useGrowers, useIsAdmin } from '@/hooks/useAdmin';

export function EstimatesScreen() {
  const master = useMasterData();
  const estimates = useEstimates();
  const season = seasonForToday(master);
  const loading = master === undefined || estimates === undefined;
  const isAdmin = useIsAdmin();
  const growers = useGrowers();
  // Growers see the open estimate week and the one before it, never anything older.
  const weeks = visibleWeekStarts();
  const groups =
    master && estimates
      ? groupByFarm(
          estimates.filter((e) => weeks.includes(e.weekStart)),
          master.farms,
        )
      : [];

  return (
    <AppFrame
      title={messages.list.title}
      subtitle={season ? messages.header.season(season.label) : undefined}
      action={<ProfileMenu />}
      offlineMessage={isAdmin ? messages.banner.offlineEstimates : undefined}
    >
      {isAdmin ? (
        <div className="fw-content" style={{ gap: 'var(--space-2)' }}>
          <AdminEstimates master={master} estimates={estimates} growers={growers} mode="all" />
        </div>
      ) : (
        <div className="fw-content" style={{ gap: 'var(--space-2)' }}>
          {loading && <SkeletonRows count={4} />}
          {!loading && groups.length === 0 && (
            <EmptyState icon="leaf-outline" title={messages.list.emptyTitle}>
              {messages.list.emptyBody}
            </EmptyState>
          )}
          {groups.map((g) => (
            <div key={g.farm.id} className="fw-group">
              <span className="fw-label fw-label--primary">{g.farm.name.toUpperCase()}</span>
              <div className="fw-rows">
                {g.rows.map((e) => (
                  <EstimateRow key={e.id} estimate={e} showVarieties />
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </AppFrame>
  );
}
